import type { Editor } from "@tiptap/react";

import type { VirtualAnchor } from "./types";

export const buildVirtualAnchor = (
  editor: Editor,
  from: number,
): VirtualAnchor | null => {
  try {
    const coords = editor.view.coordsAtPos(from);
    return {
      getBoundingClientRect: () =>
        ({
          x: coords.left,
          y: coords.top,
          left: coords.left,
          top: coords.top,
          right: coords.left,
          bottom: coords.bottom,
          width: 0,
          height: coords.bottom - coords.top,
          toJSON: () => ({}),
        }) as DOMRect,
    };
  } catch {
    return null;
  }
};
